/**
 * 2022-01-12
 * 文本模版组件 TextModule
 */

import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

const defaultStyle = {
    type: 'mm',
    theme: 'white',
    textAlign: 'left',
    width: '924px',
    backColor: 'transparent',
    margin: 0,
    iconPosition: 'left',
    iconWidth: 18,
    iconHeight: 20,
    iconMargin: 0,
    wordSpacing: '-1px',
    letterSpacing: '0.3px',
    opacity: 1,
    fontClass: '',
};

const textTypeStyle: any = {
    ll: {
        lineHeight: '130px',
        fontSize: '120px',
        color: '#03060b',
        fontFamily: 'var(--font-family-ExtraBold)',
        fontWeight: 700,
    },
    lm: {
        lineHeight: '104px',
        fontSize: '96px',
        color: '#03060b',
        fontFamily: 'var(--font-family-ExtraBold)',
        fontWeight: 700,
    },
    ls: {
        lineHeight: '72px',
        fontSize: '64px',
        color: '#03060b',
        fontFamily: 'var(--font-family-ExtraBold)',
        fontWeight: 700,
    },
    mm: {
        lineHeight: '34px',
        fontSize: '26px',
        color: '#03060b',
        fontFamily: 'var(--font-family-SemiBold)',
        fontWeight: 600,
    },
    sl: {
        lineHeight: '35px',
        fontSize: '22px',
        color: '#666666',
        fontFamily: 'var(--font-family-SemiBold)',
        fontWeight: 600,
    },
    sm: {
        lineHeight: '28px',
        fontSize: '17px',
        color: '#666666',
        fontFamily: 'var(--font-family-Medium)',
        fontWeight: 600,
    },
    ss: {
        lineHeight: '28px',
        fontSize: '17px',
        color: '#757575',
        fontFamily: 'var(--font-family-Medium)',
        fontWeight: 500,
    },
};

const defaultData = {
    text: 'Power pretty much anything',
    icon: '',
};

/**
 * style样式参数 和 data数据参数
 * * @param cssStyle{
 *  type: 文本类型 string //=> ll, lm, ls, mm, sl, sm, ss七类
 *  textAlign: 文本对齐方式 string,
 *  width: 文本长度 string,
 *  backColor: 背景颜色 string,
 *  margin: margin string,
 *  lineHeight: 行高 string,
 *  fontSize: 字体大小 string,
 *  color: 文字颜色 string,
 *  fontFamily: 粗体大小 string|number
 *  iconPosition: icon相对文本位置 // left，right
 *  iconWidth: icon图标宽 number,
 *  iconHeight: icon图标高 number,
 *  iconMargin: icon图标margin string,
 *  wordSpacing: 文本字符间距 string,
 *  opacity: 文字透明度 number,
 *  fontClass: 自带fontFamily和fontWeight的全局class string,
 * }
 * @param data{
 *  text: 文本内容 string
 *  icon: icon图标url string // 空字符串则不显示
 * }
 */

export default function TextModule({ cssStyle, data }: any) {
    const dataObj = { ...defaultData, ...data };
    const styles = {
        ...defaultStyle,
        ...textTypeStyle[cssStyle?.type || defaultStyle.type],
        ...cssStyle,
    };
    const isWhiteTheme = styles.theme === 'white' || styles.theme === '#fff' || styles.theme === '#ffffff' || styles.theme === 'transparent';
    styles.backColor = cssStyle?.backColor ?? (isWhiteTheme ? '#fff' : '#000');
    styles.color =
        cssStyle?.color ?? (isWhiteTheme ? styles.color : ['ll', 'lm', 'ls', 'mm'].includes(styles.type) ? '#fff' : styles.type === 'ss' ? '#555' : '#919191');

    return (
        <div className={`${css.textModule} textModule ${styles.fontClass}`} style={{ background: styles.backColor, display: dataObj.text ? 'block' : 'none' }}>
            <div
                className="container"
                style={{
                    justifyContent: styles.textAlign,
                    display: dataObj.text ? 'flex' : 'none',
                }}
            >
                <div
                    className="TextModule-in1"
                    style={{
                        width: styles.width,
                        margin: styles.margin,
                        textAlign: styles.textAlign,
                        fontFamily: styles.fontFamily,
                    }}
                >
                    <span className="textBox">
                        {dataObj.icon && styles.iconPosition === 'left' ? (
                            <span
                                className="icons iconsLeft"
                                style={{
                                    top: `${(parseInt(styles.lineHeight) - parseInt(styles.iconHeight)) / 2}px`,
                                    left: '-' + styles.iconMargin,
                                }}
                            >
                                {dataObj.icon}
                            </span>
                        ) : (
                            ''
                        )}
                        {!dataObj.useHtmlAttr ? (
                            <span
                                className="text"
                                style={{
                                    color: styles.color,
                                    lineHeight: styles.lineHeight,
                                    fontWeight: styles.fontWeight,
                                    fontSize: styles.fontSize,
                                    fontFamily: styles.fontClass ? 'unset' : styles.fontFamily,
                                    wordSpacing: styles.wordSpacing,
                                    letterSpacing: styles.letterSpacing,
                                    opacity: styles.opacity,
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: dataObj.text,
                                }}
                            ></span>
                        ) : (
                            <span
                                className="text"
                                style={{
                                    color: styles.color,
                                    lineHeight: styles.lineHeight,
                                    fontWeight: styles.fontWeight,
                                    fontSize: styles.fontSize,
                                    fontFamily: styles.fontClass ? 'unset' : styles.fontFamily,
                                    wordSpacing: styles.wordSpacing,
                                    letterSpacing: styles.letterSpacing,
                                    opacity: styles.opacity,
                                }}
                            >
                                {dataObj.text}
                            </span>
                        )}
                        {dataObj.icon && styles.iconPosition === 'right' ? (
                            <span
                                className="icons iconsRight"
                                style={{
                                    top: `${(parseInt(styles.lineHeight) - parseInt(styles.iconHeight)) / 2}px`,
                                    right: '-' + styles.iconMargin,
                                }}
                            >
                                {dataObj.icon}
                            </span>
                        ) : (
                            ''
                        )}
                    </span>
                </div>
            </div>
        </div>
    );
}
